<template>
    <div class="border p-2 mt-4">
        <form id="card_to_card_limitation_form">
            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="server_ip_limitation"
                        name="server_ip_limitation"
                        v-model="form_data.server_ip_limitation"
                    >
                    <label class="custom-control-label" for="server_ip_limitation">{{
                            $t('label.server_ip_limitation')
                        }}</label>
                </div>
            </kt-form-group>
            <div style="text-align: end">
                <button type="button"
                        @click="saveLimitation"
                        class="btn btn-success"
                        id="card_to_card_save_limitation"
                        v-text="$t('btn.edit')"
                >
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {cardToCardService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";

export default {
    data() {
        return {};
    },
    mounted() {
    },
    computed: {
        ...mapGetters('cardToCard', [
            'form_data', 'status'
        ]),
    },
    methods: {
        saveLimitation(e) {
            let btn = $('#card_to_card_save_limitation');
            let form = $('#card_to_card_limitation_form');

            KTApp.progress(btn);

            cardToCardService.adminUpdateGatewayLimits(this.form_data.id, {
                server_ip_limitation: this.form_data.server_ip_limitation,
            }).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                    KTApp.unprogress(btn);
                }
            )
        },
    },
}
</script>

<style>
</style>
